import { render, staticRenderFns } from "./NotificationSave.vue?vue&type=template&id=a50e6b72&"
import script from "./NotificationSave.vue?vue&type=script&lang=js&"
export * from "./NotificationSave.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSave.vue?vue&type=style&index=0&id=a50e6b72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports